import { type Theme, useMediaQuery } from '@mui/material';

const useSmallDesktopScreen = () : boolean => useMediaQuery((theme : Theme) => theme.breakpoints.down('lg'), {noSsr: true});

export default useSmallDesktopScreen;